export default "__VITE_ASSET__ce3002fe__"